import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/Users/gokhan/workspace/gokhana.dev/node_modules/gatsby-theme-chronoblog/src/components/page/index.js";
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const SEO = makeShortcode("SEO");
const AuthorBanner = makeShortcode("AuthorBanner");
const FeedSearch = makeShortcode("FeedSearch");
const Tags = makeShortcode("Tags");
const FeedItems = makeShortcode("FeedItems");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


<SEO title="Blog" description="Articles by Gökhan Ayrancıoğlu on software engineering, backend development and architecture." slug="/blogs/" mdxType="SEO" />
<AuthorBanner mdxType="AuthorBanner" />
<p>{`I have been developing software applications since my High school years. I started to work as a software engineer in 2016 and focused on backend development. `}</p>
<hr></hr>
<FeedSearch mdxType="FeedSearch" />
<Tags mdxType="Tags" />
<FeedItems mdxType="FeedItems" />

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      